import { Fragment } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
const DetailsHeader = ({
  isLoading = false,
  onBack,
  backTooltip = "Back",
  profileImage,
  defaultImage = "/profile.png",
  onProfileClick,
  title,
  status,
  chips = [],
  showProfile = false,
  profileFallback,
  onEdit,
  editTooltip = "Edit",
  editLabel = "Edit",
  editIcon = "fa fa-pencil",
  showEdit = true,
}) => {
  const getStatusClass = (status) => {
    switch ((status || "").toUpperCase()) {
      case "ACTIVE":
      case "ONLINE":
        return "status-active";
      case "INACTIVE":
      case "OFFLINE":
        return "status-inactive";
      case "STARTED":
      case "INPROGRESS":
        return "status-inprogress";
      case "COMPLETED":
        return "status-completed";
      case "CANCELLED":
        return "status-cancelled";
      case "NOT_STARTED":
      default:
        return "status-default";
    }
  };

  // const getProfileFallback = () => {
  //   if (profileFallback) {
  //     return profileFallback;
  //   }
  //   if (!title) {
  //     return "?";
  //   }
  //   return title
  //     .split(" ")
  //     .filter(Boolean)
  //     .slice(0, 2)
  //     .map((word) => word.charAt(0).toUpperCase())
  //     .join("");
  // };
  
  return (
    <div className="td-hero-card">
      <div className="td-hero-inner">
        {/* Back Button */}
        {onBack && (
          <button
            type="button"
            className="td-back-btn"
            onClick={onBack}
            title={backTooltip}
          >
            <i className="fa fa-arrow-left" />
          </button>
        )}

        {showProfile && (
          <div className="td-avatar">
            {isLoading ? (
              <div className="td-avatar-img d-flex justify-content-center align-items-center bg-light">
                <i className="fa fa-spinner fa-spin fa-lg loader" />
              </div>
            ) : (
              <>
                <img
                  src={profileImage || defaultImage}
                  alt={title || "Profile"}
                  className={`td-avatar-img ${onProfileClick ? "cursor" : ""}`}
                  onClick={onProfileClick}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = defaultImage;
                  }}
                />
                <span className="td-avatar-ring" />
              </>
            )}
          </div>
        )}

        {isLoading ? (
          <div className="td-hero-info d-flex align-items-center">
            <i className="fa fa-spinner fa-spin fa-2xl loader" />
          </div>
        ) : (
          <div
            className={`td-hero-info ${chips.length === 0 ? "td-hero-info-no-chips" : ""}`}
          >
            <div className="td-hero-name-row">
              {title && <span className="td-hero-name">{title}</span>}
              {status && (
                <span className={`td-status-badge ${getStatusClass(status)}`}>
                  <span className="td-status-dot" />
                  {status}
                </span>
              )}
            </div>

            {chips.length > 0 && (
              <div className="td-hero-meta">
                {chips.map((chip, index) => {
                  const chipId = chip.id || `tdChip-${index}`;
                  return (
                    <Fragment key={chipId}>
                      <span
                        className="td-meta-chip"
                        id={chip.tooltip ? chipId : undefined}
                      >
                        {chip.icon && (
                          <i className={`${chip.icon} td-meta-icon`} />
                        )}
                        {chip.name && (
                          <span className="mr-1">{chip.name}:</span>
                        )}
                        {chip.value}
                      </span>
                      {chip.tooltip && (
                        <UncontrolledTooltip
                          placement="bottom"
                          target={chipId}
                          delay={{ show: 100, hide: 0 }}
                        >
                          {chip.tooltip}
                        </UncontrolledTooltip>
                      )}
                    </Fragment>
                  );
                })}
              </div>
            )}
          </div>
        )}
        {showEdit && (
          <div className="td-hero-actions">
            <Button onClick={onEdit} color="deep-blue">
              <i className="fa fa-pencil mr-1" />
              Edit
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
export default DetailsHeader;
